import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('linear-progress-bar', {
  root: {
    variants: {
      skin: ['standard', 'success', 'warning', 'premium', 'neutral'],
      padding: ['none'],
      height: ['none'],
    },
    states: ['light', 'error', 'success'],
  },
  prefixIndicationContainer: {},
  barContainer: {},
  barBackground: {},
  barForeground: {},
  progressIndicationSection: {},
  indicationContainer: {},
  progressIcon: {},
  progressPercentage: {},
  suffixIndication: {},
});
